import type { ReactNode } from "react";
import { Card, Typography } from "antd";

type PageHeadProps = {
  title: string;
  leftComponent?: ReactNode;
  rightComponent?: ReactNode;
};

export function PageHead({ title, rightComponent, leftComponent }: PageHeadProps) {
  return (
    <div className={"w-full"}>
      <Card>
        <div className={"flex justify-between items-center"}>
          <div className={"flex justify-start gap-2 items-center"}>
            {leftComponent}
            <Typography.Title level={5} className={"mb-0!"}>
              {title}
            </Typography.Title>
          </div>
          {rightComponent}
        </div>
      </Card>
    </div>
  );
}
